import { render, staticRenderFns } from "./CreateDiplomatiSafiran.vue?vue&type=template&id=f9235c58&"
import script from "./CreateDiplomatiSafiran.vue?vue&type=script&lang=js&"
export * from "./CreateDiplomatiSafiran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports